import React from 'react';
import { Ruler, HelpCircle } from 'lucide-react';

/**
 * Компонент для ввода измерений окружностей тела
 */
const MeasurementsSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  // Проверяем, нужно ли показывать обычные измерения (для метода ВМС)
  const showNavyMeasurements = formData.measurementMethod === 'navy';
  
  if (!showNavyMeasurements) {
    return null;
  }

  return (
    <div className="mb-6 bg-emerald-50 dark:bg-emerald-900/20 p-4 rounded-lg border border-emerald-200 dark:border-emerald-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Ruler className="w-5 h-5 mr-2 text-emerald-500" />
        Измерения окружностей тела
      </h3>
      
      <div className="mb-4 p-3 bg-emerald-100 dark:bg-emerald-900/30 border border-emerald-200 dark:border-emerald-700 rounded-lg">
        <div className="flex items-start">
          <HelpCircle className="w-5 h-5 text-emerald-600 dark:text-emerald-400 mr-3 mt-0.5 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-medium text-emerald-700 dark:text-emerald-300 mb-1">
              Как правильно измерять окружности
            </h4>
            <ul className="text-xs text-emerald-600 dark:text-emerald-400 space-y-1">
              <li>• Шея: измеряйте ниже гортани, перпендикулярно длинной оси шеи</li>
              <li>• Талия: измеряйте на уровне пупка при расслабленном животе</li>
              {formData.gender === 'female' && (
                <li>• Бедра: измеряйте в самой широкой части ягодиц</li>
              )}
              <li>• Используйте мягкую измерительную ленту и не затягивайте ее слишком туго</li>
            </ul>
          </div>
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Окружность шеи */}
        <div>
          <label htmlFor="neck" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Окружность шеи (см)
          </label>
          <input
            type="number"
            id="neck"
            name="neck"
            value={formData.neck}
            onChange={handleInputChange}
            min="20"
            max="80"
            step="0.1"
            className={`form-input w-full ${errors.neck ? 'input-error' : ''}`}
            placeholder="Например: 37"
          />
          {errors.neck && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">{errors.neck}</p>
          )}
        </div>

        {/* Окружность талии */}
        <div>
          <label htmlFor="waist" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Окружность талии (см)
          </label>
          <input
            type="number"
            id="waist"
            name="waist"
            value={formData.waist}
            onChange={handleInputChange}
            min="40"
            max="200"
            step="0.1"
            className={`form-input w-full ${errors.waist ? 'input-error' : ''}`}
            placeholder="Например: 85"
          />
          {errors.waist && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">{errors.waist}</p>
          )}
        </div>

        {/* Окружность бедер (только для женщин) */}
        {formData.gender === 'female' && (
          <div>
            <label htmlFor="hip" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Окружность бедер (см)
            </label>
            <input
              type="number"
              id="hip"
              name="hip"
              value={formData.hip}
              onChange={handleInputChange}
              min="50"
              max="200"
              step="0.1"
              className={`form-input w-full ${errors.hip ? 'input-error' : ''}`}
              placeholder="Например: 95"
            />
            {errors.hip && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">{errors.hip}</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default MeasurementsSection;